import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "call-log",
      path: "call-log",
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "phone",
        title: i18n.global.t("Call Log"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/CallLog"),
    },
  ],

  dialogs: [
    {
      name: "call-log-view",
      path: "/sales-tools/call-log/:logID/view",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "phone",
        title: i18n.global.t("Call Log"),
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/CallLogView"),
    },
    {
      name: "call-log-new",
      path: "/sales-tools/call-log/new",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "phone",
        title: i18n.global.t("New Call Log"),
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/CallLogEdit"),
    },
    {
      name: "call-log-edit",
      path: "/sales-tools/call-log/:logID/edit",
      props: true,
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "phone",
        title: i18n.global.t("Edit Call Log"),
        color: "primary",
      },
      component: () => import("../../../dialogs/employee/CallLogEdit"),
    },
  ],
};
